<!--
Author: TangChen
Date: 2018-09-27
Desc: 账户绑定组件
 -->
<template>
    <div class="comp-bind-acct comp">
        <div class="acct-con">
            <nav-bar :navs="navs" />
            <div v-show="!ocrShow" class="check-acct">
                <!-- 验证证件信息 -->
                <el-form
                    v-if="!checked"
                    ref="pwdForm"
                    :model="pwdForm"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <div v-if="!hasTranAcct" class="cut-off-line top">
                        <span>选择银行</span>
                    </div>
                    <el-form-item
                        v-if="!hasTranAcct"
                        label="所属银行："
                        prop="bankType"
                        class="bank"
                    >
                        <div
                            class="bank-msg"
                            :style="{ opacity: bankInfo.channelid ? 1 : 0 }"
                            v-on:click.prevent="showBank"
                        >
                            <div
                                v-if="bankInfo.channelid"
                                class="bank-img-sel clear"
                                :class="{ 'bg-w': bankInfo.channelid }"
                            >
                                <img
                                    :src="$util.getImg(bankInfo.bankcode)"
                                    title="bank-img"
                                    alt=""
                                />
                                <span class="k-text-flow">
                                    {{ bankInfo.bankname.toString().substr(0, 6) }}
                                </span>
                                <i class="paycenter" aria-hidden="true">
                                    {{ bankInfo.paycentername.toString().substr(0, 4) }}
                                </i>
                            </div>
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankType"
                            placeholder="请选择所属银行"
                            :maxlength="20"
                            suffix-icon="fa fa-money-check"
                        />
                    </el-form-item>
                    <!--<el-form-item v-if="bankInfo.hkopenflag==='1'" label="开通汇款支付：" prop="hkopenflag" class="form-text">-->
                    <!--<el-radio-group v-model="acctInfo.hkopenflag">-->
                    <!--<el-radio :label="'1'">-->
                    <!--是-->
                    <!--</el-radio>-->
                    <!--<el-radio :label="'0'">-->
                    <!--否-->
                    <!--</el-radio>-->
                    <!--</el-radio-group>-->
                    <!--</el-form-item>-->
                    <el-form-item v-if="!hasTranAcct" label="银行卡号码：" prop="bankNo">
                        <div
                            class="bank-code el-message--warning"
                            :class="{ show: showBankCard && pwdForm.bankNo !== '' }"
                        >
                            {{ $util.getNewCard(pwdForm.bankNo) }}
                        </div>
                        <el-input
                            v-model.trim="pwdForm.bankNo"
                            placeholder="请输入银行卡号码"
                            :maxlength="20"
                            v-on:focus="showBankCard = true"
                            v-on:blur="showBankCard = false"
                        />
                    </el-form-item>
                    <div v-if="!hasTranAcct" class="cut-off-line">
                        <span>
                            (请填写您在该银行开户时提供的身份信息(非身份证开户需先填写信息，再上传证件)
                        </span>
                    </div>
                    <el-form-item v-if="!hasTranAcct" label="开户姓名：" prop="userName">
                        <el-input
                            v-model.trim="pwdForm.userName"
                            :placeholder="'请' + holderText + '真实姓名'"
                            :maxlength="20"
                            :disabled="dis || dateSet.dis"
                        />
                    </el-form-item>
                    <el-form-item label="开户证件：" prop="certType" class="cert-types-line">
                        <el-select
                            v-model="pwdForm.certType"
                            placeholder="请选择证件类型"
                            :style="{ width: btnStyle }"
                            :disabled="dis"
                            v-on:change="checkCertNoAgain"
                        >
                            <el-option
                                v-for="item in certTypes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-button
                            v-show="ocrUpdBtnS"
                            :disabled="ocrDis"
                            type="primary"
                            v-on:click="gotoOcr"
                        >
                            {{ ocrBtnText }}
                        </el-button>
                    </el-form-item>
                    <el-form-item label="证件号码：" prop="certNo">
                        <el-input
                            v-model.trim="pwdForm.certNo"
                            :placeholder="'请' + holderText + '证件号码'"
                            :maxlength="20"
                            :disabled="dis || dateSet.dis"
                            v-on:blur="initBirthdate"
                        />
                    </el-form-item>
                    <el-form-item v-if="!hasTranAcct" label="证件有效期：" prop="vailddate">
                        <date-picker
                            :date="dateSet"
                            v-on:date-get="dateInterval"
                            v-on:valid-get="dealValid"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="!hasTranAcct"
                        label="出生日期："
                        prop="birthdate"
                        class="birthdate-select"
                    >
                        <date-picker :date="dateSetBirth" v-on:date-get="dateInterval_birth" />
                    </el-form-item>
                    <el-form-item
                        v-if="!hasTranAcct"
                        label="银行预留手机号码："
                        prop="mobile"
                        :class="{ 'form-text': !(bankInfo && bankInfo.identifytype === '1') }"
                    >
                        <el-input
                            v-model.trim="pwdForm.mobile"
                            placeholder="请输入银行预留手机号码"
                            :maxlength="11"
                        />
                    </el-form-item>
                    <!--<el-form-item
                        v-if="bankInfo && bankInfo.identifytype==='1'"
                        label="手机验证码："
                        prop="verifyCode"
                    >
                        <el-input
                            v-model.trim="pwdForm.verifyCode"
                            placeholder="请输入手机验证码"
                            :maxlength="6"
                        >
                            <el-button
                                slot="append"
                                class="get-verify"
                                :disabled="time>0"
                                v-on:click="mobileCheck"
                            >
                                {{ btnMsg }}
                            </el-button>
                        </el-input>
                    </el-form-item>-->
                    <el-form-item>
                        <div style="width: 50%">
                            <el-button type="primary" class="medium" v-on:click="mobileCheck">
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="backPage">返回</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="openTran" label="" class="form-text">
                        <div class="step-info error">
                            <span>{{ openTran + "，无法进行绑定。" }}</span>
                            <span
                                v-if="openTran.indexOf('开户') > -1"
                                class="info-btn"
                                v-on:click.prevent="$router.push({ name: 'bindnewacct' })"
                            >
                                立即开立交易账号
                            </span>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 验证交易密码 -->
                <el-form
                    v-if="checkTPwd"
                    ref="acctInfo"
                    :model="acctInfo"
                    :rules="rules"
                    label-width="260px"
                    class="pwdForm"
                    inline-message
                    v-on:submit.native.prevent
                >
                    <!-- <el-form-item label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.name }}
                        </div>
                    </el-form-item> -->
                    <el-form-item label="证件号码：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.certNo }}
                        </div>
                    </el-form-item>
                    <el-form-item label="交易密码：" prop="pwd">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            :type="pwdType"
                            placeholder="请输入以上交易账号对应的交易密码"
                            :maxlength="16"
                        >
                            <i
                                slot="suffix"
                                aria-hidden="true"
                                :class="iconCla"
                                v-on:click="pwdTypeChange"
                            />
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="width: 50%">
                            <el-button
                                type="primary"
                                class="medium"
                                v-on:click="submitInfo('acctInfo')"
                            >
                                下一步
                            </el-button>
                            <el-button class="medium" v-on:click="returnCheck()">返回</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- 开户信息 -->
                <div v-if="opentAcct">
                    <open-acct :data="openPar" v-on:get-acct="getAcct" />
                </div>
            </div>
            <el-row v-show="ocrShow" class="investor-data-up">
                <el-alert
                    title="注意：上传的图片大小每张不能超过5M，格式类型只支持bmp，jpg，jpeg，png，非身份证每张不能超过1.5M且请至少上传两张有效证件照。请仔细核对您的证件信息，如信息识别有误请您重新录入"
                    type="warning"
                    show-icon
                    :closable="false"
                />
                <ocr-upd
                    v-if="!isIE9 && pwdForm.certType == '00' && ocrShow"
                    :formdatas="pwdForm"
                    v-on="{ success: imgUp, back: regression }"
                />
                <ocr-upd-other
                    v-else-if="!isIE9 && pwdForm.certType != '00' && ocrShow"
                    :formdatas="pwdForm"
                    v-on="{ success: imgUp, back: regression }"
                />
                <div v-else class="cant-up">
                    <div class="cant-info">
                        为保证上传证件质量，暂不支持IE9浏览器上传认证证件照，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。
                    </div>
                    <el-button class="medium" v-on:click="$router.back()">确定</el-button>
                </div>
            </el-row>
        </div>
        <bank-lists
            v-if="$route.name == 'bindnewacct'"
            :bank-visible="bankVisible"
            v-on:bank-hide="getBankMsg"
        />
        <result
            v-if="bindResult"
            :result="result"
            v-on:login-now="findPwd"
            v-on:return-login="backPage"
        />
        <agreement v-model="protocol" :data="agrType" v-on:all-read="agreePro"></agreement>
        <mobile-code :mobile-visible="mobileVisible" v-on:verify-in="mobileCode" />
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
    </div>
</template>
<script>
import bankLists from "@/components/form/bankLists.vue";
import openAcct from "@/components/form/openAcct.vue";
import navBar from "@/components/layout/navBar.vue";
import result from "@/components/layout/result.vue";
import agreement from "@/components/form/agreement.vue";
import ocrUpd from "@/components/form/ocrUpd.vue";
import ocrUpdOther from "@/components/form/ocrUpdOther.vue";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import imgCode from "@/components/layout/imgCode.vue";
import mobileCode from "@/components/layout/mobileCode.vue";
import userApi from "@/api/user";

export default {
    name: "BindAcct",
    components: {
        navBar,
        bankLists,
        openAcct,
        mobileCode,
        result,
        agreement,
        ocrUpd,
        ocrUpdOther,
        datePicker,
        imgCode
    },
    props: {
        way: Boolean
    },
    data() {
        return {
            dialogVisible: false,
            mobileVisible: false,
            showBankCard: false, // 是否着重显示银行卡号码
            agrType: "add", // 协议类型，增卡协议
            time: 0, // 验证码再次发送间隔
            countrycode: [], // 国家码
            machinecode: [], // 座机地区码
            natural: [], // 自然人标识
            profession: [],
            pwdForm: {
                // 表单参数配置
                userName: "",
                certType: "00",
                certNo: "",
                vailddate: "",
                bankType: "",
                bankNo: "",
                mobile: "",
                verifyCode: "",
                birthdate: "",
                address: "",
                income: "", // 年收入
                companyname: "", // 单位工作名称
                profession: "", // 投资人职业
                validtype: "" // 证件是否长期有效
            },
            setInfoFlag: "1", // 纯代销注册状态标示
            protocol: false,
            pwdType: "password",
            iconCla: "fa fa-eye-slash",
            acctInfo: {
                // 交易账户信息
                name: "",
                certNo: "",
                pwd: "",
                hkopenflag: ""
            },
            dis: false,
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    ctd: "秒后自动跳转用户中心",
                    time: 10,
                    event: "return-login"
                }
            },
            bindResult: false, // 是否显示绑定结果页
            bankVisible: false, // 是否弹出银行卡列表
            checked: false, // 手机或银行卡校验是否通过
            navs: [
                { val: "验证证件信息", active: true },
                { val: "验证交易密码" },
                { val: "完成绑定", icon: "fa fa-check" }
            ], // 导航栏配置
            certTypes: [], // 证件类型
            openTran: "", // 重新开立交易账户提示信息
            btnMsg: "获取短信验证码",
            hasTranAcct: false, // 是否有交易账号
            locked: false, // 是否已发送短信验证码
            bankInfo: {},
            checkTPwd: false, // 显示验证交易密码页面
            opentAcct: false,
            openPar: {},
            rules: {
                // 校验规则
                userName: [{ validator: this.checkName, trigger: "blur" }],
                income: [{ required: true, message: "请输入年收入", trigger: "blur" }],
                certType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
                certNo: [
                    //                        {required: true, message: "请输入证件号码", trigger: "blur"},
                    { validator: this.checkCertNo, trigger: "blur" }
                ],
                vailddate: [
                    { validator: this.checkVailddate, trigger: "blur" }
                    //                        {required: true, message: "请选择证件有效期", trigger: "blur"}
                ],
                birthdate: [
                    { validator: this.checkBirthdate, trigger: "blur" }
                    //                        {required: true, message: "请选择出生日期", trigger: "blur"}
                ],
                bankType: [{ required: true, message: "请选择所属银行", trigger: "blur" }],
                pwd: [{ required: true, message: "请输入绑定账号的交易密码", trigger: "blur" }],
                bankNo: [
                    { required: true, message: "请输入银行卡号码", trigger: "blur" },
                    { validator: this.$util.validateBankNum, trigger: "blur" }
                ],
                mobile: [
                    { required: true, message: "请输入银行预留手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                verifyCode: [{ validator: this.$util.validateVerifyCode, trigger: "blur" }]
            },
            ocrBtnText: "上传证件照",
            ocrShow: false,
            isIE9: false,
            ocrUpdBtnS: false,
            hasOcr: "0",
            dateSet: { type: "3", max: "", dis: false, val: "", text: "请选择证件有效期" },
            dateSetBirth: { type: "3", max: "", dis: true, val: "", text: "请选择出生日期" },
            btnStyle: "50%",
            holderText: "输入",
            ocrupdflag: "0" // 上传成功标示
        };
    },
    computed: {
        ocrDis: function () {
            return !(
                (this.pwdForm.certNo &&
                    (!this.hasTranAcct ? this.pwdForm.userName : true) &&
                    this.pwdForm.vailddate &&
                    this.pwdForm.birthdate) ||
                this.pwdForm.certType == "00"
            );
        }
    },
    watch: {
        hasTranAcct(val) {
            this.returnCheck();
        },
        "pwdForm.certType"(val) {
            if (val === "00") {
                this.dateSetBirth.dis = true;
            } else {
                this.dateSetBirth.dis = false;
            }
            if (this.setInfoFlag === "0") {
                this.setInfoFlag = "1";
                return false;
            }
            if (this.ocrUpdBtnS === true) {
                this.dateSet.dis = !!(val == "00" && this.hasOcr == "1");
                this.dateSetBirth.dis = !!(val == "00" && this.hasOcr == "1");
            }
            this.pwdForm.userName = "";
            this.pwdForm.certNo = "";
            this.pwdForm.vailddate = "";
            this.pwdForm.birthdate = "";
            this.pwdForm.address = "";
            this.ocrupdflag = "0";
            this.$set(this.dateSet, "val", "");
            this.$set(this.dateSet, "time", new Date().getTime());
            this.$set(this.dateSetBirth, "val", "");
            this.$set(this.dateSetBirth, "time", new Date().getTime());
            this.$refs.pwdForm.clearValidate();
        },
        "dateSet.dis"(val) {
            this.holderText = val == true ? "上传证件获取" : "输入";
            this.$set(
                this.dateSet,
                "text",
                val == true ? "请上传证件获取证件有效期" : "请选择证件有效期"
            );
            this.$set(
                this.dateSetBirth,
                "text",
                val == true ? "请上传证件获取出生日期" : "请选择出生日期"
            );
        }
    },
    created() {
        this.countrycode = this.$cache.getDict("150136");
        this.machinecode = this.$cache.getDict("150137");
        this.natural = this.$cache.getDict("120200");
        this.profession = this.$cache.getDict("150141");
        this.certTypes = this.$cache.getDict("130007");
        const conf = this.$util.getConfig().const;
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.dateSetBirth.max = this.$util.fmtDate(birthmax);
        this.dateSetBirth.min = this.$util.fmtDate("19000101");
        // this.hasOcr = this.$cache.getParams("hasocr");
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
        // this.certTypes = this.$cache.getDict("130007");
        const info = this.$cache.getUser();
        if (info.usertype === "2" && info.bindflag !== "1") {
            this.pwdForm.certType = info.certificatetype;
            this.pwdForm.certNo = info.certificateno;
            this.pwdForm.vailddate = info.vailddate;
            this.pwdForm.birthdate = info.birthdate;
            if (info.vailddate.trim())
                this.$set(this.dateSet, "val", this.$util.fmtDate(info.vailddate));
            this.$set(this.dateSet, "time", new Date().getTime());
            if (info.birthdate.trim())
                this.$set(this.dateSetBirth, "val", this.$util.fmtDate(info.birthdate));
            this.$set(this.dateSetBirth, "time", new Date().getTime());
            this.pwdForm.userName = info.custname;
            this.dis = true;
            this.setInfoFlag = "0";
        }
        this.bindWay(this.way);
        if (!this.hasTranAcct) {
            // this.getOcrOpenStatus();
        }
    },
    methods: {
        getVerifyCode(val) {
            this.dialogVisible = false;
            if (val) {
                this.sendBank(val);
            }
        },
        /* 回退到鉴权界面 */
        returnCheck() {
            this.checked = false;
            this.locked = false;
            this.checkTPwd = false;
            this.opentAcct = false;
            this.openTran = "";
            this.bindWay(this.hasTranAcct);
        },
        // 改变证件类型再次校验证件号码
        checkCertNoAgain() {
            this.pwdForm.userName = "";
            this.pwdForm.certNo = "";
            this.pwdForm.vailddate = "";
            this.pwdForm.birthdate = "";
            this.pwdForm.address = "";
            this.ocrupdflag = "0";
            this.$refs.pwdForm.validateField(["userName", "certNo", "vailddate", "birthdate"]);
        },
        agreePro(val) {
            this.protocol = false;
            if (!val) return;
            if (this.bankInfo.identifytype === "1") {
                this.mobileVisible = true;
            } else {
                this.sendBank();
            }
        },
        // 获取用户信息
        async getAcct(val) {
            if (!val) {
                return this.returnCheck();
            }
            const _this = this;
            // 获取用户性别
            let sexVal = "";
            if (_this.pwdForm.certType === "00") {
                sexVal = _this.getSex(_this.pwdForm.certNo);
            } else {
                sexVal = val.sex;
            }
            const conf = this.$util.getConfig().const;
            const info = this.$cache.getUser();

            const _x = {
                // certificatetype: this.pwdForm.certificatetype,
                // vailddate: _this.pwdForm.vailddate,

                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                depositname: this.pwdForm.userName,
                validtype: this.pwdForm.validtype,
                paychannel: this.bankInfo.paycenterid,
                bankcode: this.bankInfo.bankcode,
                custname: this.pwdForm.userName, // 客户名称
                validdate: this.pwdForm.vailddate, // 证件有效期
                birthday: _this.pwdForm.birthdate,

                mobilenocycode: val.beneficiarytelnocycode,
                tradepwd: _this.$util.enc(val.pwd),
                tradepassword: _this.$util.enc(val.pwd),
                delivertype: val.delivertype,
                deliverway: val.deliverway,
                cardtelno: _this.pwdForm.mobile,
                mobileno: _this.pwdForm.mobile,
                email: val.email,
                address: val.address, //
                telcycode: val.telnocycode,
                telareacode: val.telnoareacode,
                telno: val.telno,
                fax: val.fax,
                faxcycode: val.faxcycode,
                faxareacode: val.faxareacode,
                postcode: val.postcode,
                sex: sexVal,
                bankprovince: val.bankprovince,
                bankcity: val.city,
                bankname: val.bankname,
                hkopenflag: this.acctInfo.hkopenflag,
                assetssource: val.assetssource,
                country: val.country,
                otherprovince: val.otherprovince,
                isdigniaryorceo: val.isdigniaryorceo,
                belongregion: val.belongregion,
                location: val.location,
                livingcountry: val.cncountry,
                branchnum: val.branchcode,
                birthdate: _this.pwdForm.birthdate,
                beneficiary: val.beneficiary,
                beneficiarytype: val.beneficiarytype,
                beneficiaryno: val.beneficiaryno,
                beneficiarydate: val.beneficiarydate,
                beneficiarysex: val.beneficiarysex,
                beneficiarybirthday: val.beneficiarybirthday,
                occupation: val.occupation,
                vocationsupple: val.vocationsupple,
                // benefisself: val.benefisself,
                // beneficiaryaddr: val.beneficiaryaddr,
                livingaddressprovince: val.cnprovince,
                livingaddresscity: val.cncity,
                livingaddresscounty: val.cncounty,
                livingaddress: val.address,
                specialpersonflag: val.natural,
                educationlevel: val.educationlevel,
                addresscity: val.cncity,
                addresscounty: val.county,
                beneficiarycountry: val.beneficiarycountry, // 受益人国家
                beneficiaryaddrprovince: val.beneficiaryaddrprovince, //  受益人省
                beneficiaryaddrcity: val.beneficiaryaddrcity, // 受益人城市
                beneficiaryaddrcounty: val.beneficiaryaddrcounty, // 受益人县
                beneficiaryemail: val.beneficiaryemail, // 受益人邮箱
                beneficiarypostcode: val.beneficiarypostcode, // 受益人邮编
                benefisself: val.benefisself, // 受益人是否是本人
                beneficiaryvocation: val.beneficiaryvocation, // 受益人职业
                beneficiarytelnocycode: val.beneficiarytelnocycode, // 国家码
                beneficiarytelnoareacode: val.beneficiarytelnoareacode, // 国家码
                beneficiarytelno: val.beneficiarytelno, // 手机号
                beneficiaryaddr: val.beneficiaryaddr, // 受益人详细地址
                benefrelation: val.benefrelation,
                actualctrladdr: val.actualctrladdr, // 控制人
                actualctrladdrcity: val.actualctrladdrcity,
                actualctrladdrcounty: val.actualctrladdrcounty,
                actualctrladdrprovince: val.actualctrladdrprovince,
                actualctrlbirthday: val.actualctrlbirthday,
                actualctrlcountry: val.actualctrlcountry,
                actualctrlemail: val.actualctrlemail,
                actualctrlidcode: val.actualctrlidcode,
                actualctrlidtype: val.actualctrlidtype,
                actualctrlname: val.actualctrlname,
                actualctrlpostcode: val.actualctrlpostcode,
                actualctrlsex: val.actualctrlsex,
                actualctrltelno: val.actualctrltelno,
                actualctrltelnocycode: val.actualctrltelnocycode,
                actualctrltelnoareacode: val.actualctrltelnoareacode,
                actualctrlvalidate: val.actualctrlvalidate,
                actualctrlvocation: val.actualctrlvocation,
                actualisself: val.actualisself,
                actualrelation: val.actualrelation,
                actualctrlvalitype: val.actualctrlvalitype,
                benefitvalidtype: val.benefitvalidtype
            };
            const accRistRes = await userApi.acctRiskListManage({
                invtp: `1`,
                opaction: "Q",
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo
            });
            if (accRistRes.data.length > 0) {
                this.$message.warning("账号为风险客户，请联系客服进行开户操作!");
                return false;
            }
            const openAcctRes = await userApi.openAcct(_x);
            _this.navs = [
                { val: "身份验证", active: true },
                { val: "补充资料", active: true },
                {
                    val: "完成绑定",
                    icon: "fa fa-check",
                    active: true
                }
            ];
            _this.opentAcct = false;
            _this.bindResult = true;
            if (openAcctRes.code === "0") {
                setTimeout(() => {
                    _this.$cache.setBinded(true);
                    _this.$cache.refreshUser();
                }, 3000);
                _this.result.msg = "您已成功绑定证件号为" + _this.pwdForm.certNo + "的交易账户";
            } else {
                _this.result.cla = "register-fail";
                _this.result.msg = openAcctRes.msg;
            }

            // _this.$util.request("acct/opentradeacct/individual", _x, "POST").then(res => {
            //     /*let _param = {
            //         "isdigniaryorceo":val.specialpersonflag,
            //         "assetssource":val.assetssource,
            //     }*/
            //     //                                _this.$util.adddigniaryorceo(_param);
            //     _this.navs = [{ val: "身份验证", active: true }, { val: "补充资料", active: true }, {
            //         val: "完成绑定",
            //         icon: "fa fa-check",
            //         active: true
            //     }];
            //     _this.opentAcct = false;
            //     _this.bindResult = true;
            //     if (res.data) {
            //         _this.$cache.refreshUser();
            //         _this.result.msg = "您已成功绑定证件号为" + _this.pwdForm.certNo + "的交易账户";
            //     } else {
            //         _this.result.cla = "register-fail";
            //         _this.result.msg = res.msg;
            //     }
            // });

            //                 _this.$util.request("acct/common/riskycust", {
            //                     certificatetype: this.pwdForm.certType,
            //                     certificateno: this.pwdForm.certNo,
            //                     invtp: "1"
            //                 }, "GET").then(res => {
            //                     if (res.data) {
            //                         if (res.data[0].flag === "1") {
            //                             _this.$message.warning("账号为风险客户，请联系客服进行开户操作!");
            //                             return false;
            //                         } else {
            //                             _this.$util.request("acct/opentradeacct/individual", _x, "POST").then(res => {
            //                                 /*let _param = {
            //                                     "isdigniaryorceo":val.specialpersonflag,
            //                                     "assetssource":val.assetssource,
            //                                 }*/
            // //                                _this.$util.adddigniaryorceo(_param);
            //                                 _this.navs = [{val: "身份验证", active: true}, {val: "补充资料", active: true}, {
            //                                     val: "完成绑定",
            //                                     icon: "fa fa-check",
            //                                     active: true
            //                                 }];
            //                                 _this.opentAcct = false;
            //                                 _this.bindResult = true;
            //                                 if (res.data) {
            //                                     _this.$cache.refreshUser();
            //                                     _this.result.msg = "您已成功绑定证件号为" + _this.pwdForm.certNo + "的交易账户";
            //                                 } else {
            //                                     _this.result.cla = "register-fail";
            //                                     _this.result.msg = res.msg;
            //                                 }
            //                             });
            //                         }
            //                     } else {
            //                         _this.result.cla = "register-fail";
            //                         _this.result.msg = res.msg;
            //                     }
            //                 });
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        // 账户绑定选项处理
        bindWay(val) {
            this.hasTranAcct = val;
            if (!val) {
                this.navs = [
                    { val: "身份验证", active: true },
                    { val: "补充资料" },
                    { val: "完成绑定", icon: "fa fa-check" }
                ];
            } else {
                this.navs = [
                    { val: "验证身份信息", active: true },
                    { val: "验证交易密码" },
                    { val: "完成绑定", icon: "fa fa-check" }
                ];
            }
        },
        // 根据身份证号判断性别
        getSex(psidno) {
            let sexno = "";
            if (psidno.length === 18) {
                sexno = psidno.substring(16, 17);
            } else if (psidno.length === 15) {
                sexno = psidno.substring(14, 15);
            } else {
                return false;
            }
            const tempid = sexno % 2;
            return tempid === 0 ? "0" : "1";
        },
        /* 回到首页 */
        findPwd() {
            this.$router.push("/home");
        },
        /* 显示用户信息补充页面 */
        showAcctPage() {
            this.checked = true;
            this.opentAcct = true;
            this.openPar = {
                certType: this.pwdForm.certType,
                address: this.pwdForm.address,
                bankid: this.bankInfo.bankcode,
                isBranch: this.bankInfo.isneedbank,
                certNo: this.pwdForm.certNo
            };
            this.navs = [
                { val: "身份验证", active: true },
                { val: "补充资料", active: true },
                {
                    val: "完成绑定",
                    icon: "fa fa-check"
                }
            ];
        },
        mobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 提交表单数据,校验手机验证码 */
        async submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                // if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                //     this.$message.warning("请先上传有效证件照");
                //     return false;
                // }
                if (valid) {
                    if (!this.hasTranAcct) {
                        if (this.bankInfo.identifytype === "1") {
                            if (!this.locked) {
                                this.$message({
                                    type: "warning",
                                    message: "请先发送手机短信验证码"
                                });
                                return false;
                            }
                        }
                        this.protocol = true;
                    } else {
                        // 查询账户绑定情况
                        const res = await userApi.isOpenAcct({
                            certificatetype: this.pwdForm.certType,
                            certificateno: this.pwdForm.certNo
                        });
                        //  const res =  {
                        //     "head": {},
                        //     "msg": "请求处理成功",
                        //     "fail": false,
                        //     "code": "0",
                        //     "success": true,
                        //     "detail": "",
                        //     "data": {
                        //         "isopenacct": "1",
                        //         "mobileno": "18899990000"
                        //     }
                        // }
                        if (res.code === "0") {
                            this.acctInfo = {
                                name: ``,
                                certNo: this.pwdForm.certNo
                            };
                            this.checkTPwd = true;
                            this.checked = true;
                            this.navs = [
                                { val: "验证证件信息", active: true },
                                {
                                    val: "验证交易密码",
                                    active: true
                                },
                                { val: "完成绑定", icon: "fa fa-check" }
                            ];
                        }

                        // this.$util.request("acct/bindtradeacct/status", {
                        //     certificatetype: this.pwdForm.certType,
                        //     certificateno: this.pwdForm.certNo,
                        //     custname: this.pwdForm.userName
                        // }).then(res => {
                        //     if (res.data) {
                        //         // 账户状态0-已绑定 1-未开户 2-已开户
                        //         const _x = res.data[0].status;
                        //         if (_x === "2") {
                        //             this.acctInfo = {
                        //                 name: res.data[0].custname,
                        //                 certNo: this.pwdForm.certNo
                        //             };
                        //             this.checkTPwd = true;
                        //             this.checked = true;
                        //             this.navs = [{val: "验证证件信息", active: true}, {
                        //                 val: "验证交易密码",
                        //                 active: true
                        //             }, {val: "完成绑定", icon: "fa fa-check"}];
                        //         } else {
                        //             this.openTran = _x === "0" ? "该交易账号已绑定其他账户" : "您提供的证件尚未在我司开户";
                        //         }
                        //     }
                        // });
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        async submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const encNum = _this.$util.enc(_this.acctInfo.pwd);
                    if (_this.hasTranAcct) {
                        const res = await userApi.bindAccount({
                            certificatetype: this.pwdForm.certType,
                            certificateno: this.pwdForm.certNo,
                            tradepassword: encNum
                        });
                        // const res ={
                        //     "code":"0",
                        //     "msg":"调用成功!",
                        //     "detail":"",
                        //     "head":{},
                        //     "data":
                        //     {"isbind":"1"}
                        // }

                        // {
                        //     "code": "100301",
                        //     "msg": "证件号[certificateno]不能为空",
                        //     "detail": "",
                        //     "head": {
                        //         "level": "2"
                        //     },
                        //     "body": null
                        // }
                        if (res.code === "0") {
                            _this.navs = [
                                { val: "验证证件信息", active: true },
                                {
                                    val: "验证交易密码",
                                    active: true
                                },
                                { val: "完成绑定", icon: "fa fa-check", active: true }
                            ];
                            _this.checkTPwd = false;
                            _this.bindResult = true;
                            if (res.data) {
                                // _this.$cache.refreshUser();
                                _this.result.msg =
                                    "您已成功绑定证件号为" + _this.acctInfo.certNo + "的交易账户";
                                _this.$cache.setBinded(true);
                                setTimeout(() => {
                                    _this.$cache.refreshUser();
                                }, 3000);
                                /* 更新出生日期和有效期 */
                                /* _this.$util.request("acct/cust/profile", {
                                        "isOcrType": "1",
                                        "certificateno": _this.pwdForm.certNo,
                                        "certificatetype": _this.pwdForm.certType,
                                        "vailddate": _this.pwdForm.vailddate,
                                        "birthdate": _this.pwdForm.birthdate,
                                        tradepwd: encNum
                                    }, "PUT").then(res => {
                                        if (res.data) {
                                            _this.$cache.refreshUser();
                                        }
                                    }); */
                            } else {
                                _this.result.cla = "register-fail";
                                _this.result.msg = res.msg;
                            }
                        }

                        // _this.$util.request("acct/bindtradeacct/bind", {tradepwd: encNum}, "POST").then(res => {
                        //     _this.navs = [{val: "验证证件信息", active: true}, {
                        //         val: "验证交易密码",
                        //         active: true
                        //     }, {val: "完成绑定", icon: "fa fa-check", active: true}];
                        //     _this.checkTPwd = false;
                        //     _this.bindResult = true;
                        //     if (res.data) {
                        //         //_this.$cache.refreshUser();
                        //         _this.result.msg = "您已成功绑定证件号为" + _this.acctInfo.certNo + "的交易账户";
                        //         _this.$cache.refreshUser();
                        //         /* 更新出生日期和有效期 */
                        //         /*_this.$util.request("acct/cust/profile", {
                        //                 "isOcrType": "1",
                        //                 "certificateno": _this.pwdForm.certNo,
                        //                 "certificatetype": _this.pwdForm.certType,
                        //                 "vailddate": _this.pwdForm.vailddate,
                        //                 "birthdate": _this.pwdForm.birthdate,
                        //                 tradepwd: encNum
                        //             }, "PUT").then(res => {
                        //                 if (res.data) {
                        //                     _this.$cache.refreshUser();
                        //                 }
                        //             });*/
                        //     } else {
                        //         _this.result.cla = "register-fail";
                        //         _this.result.msg = res.msg;
                        //     }
                        // });
                        return false;
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            // todo
            let param = {
                biztype: "03",
                smscode: val,
                mobileno: this.pwdForm.mobile
            };
            const res = await userApi.checkBindCardSms(param);
            if (res.code === "0") {
                this.showAcctPage();
            }

            // this.$util.request("acct/opentradeacct/authcheckmsg", {verifycode: val}, "POST").then(res => {
            //     if (res.data) {
            //         this.showAcctPage();
            //     }
            // });
        },
        /* 显示银行卡列表弹框 */
        showBank() {
            this.bankVisible = !this.bankVisible;
        },
        /* 回调银行卡信息 */
        getBankMsg(val) {
            this.bankVisible = false;
            if (val && val.bank) {
                this.bankInfo = val.bank;
                this.pwdForm.bankType = this.bankInfo.channelid;
                this.bankInfo.hkopenflag = val.bank.hkopenflag ? val.bank.hkopenflag : "0";
            }
        },
        /* 校验用户姓名 */
        checkName(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                if (this.$util.isEmpty(value)) {
                    if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                        callback(new Error("请上传证件获取姓名"));
                    } else {
                        callback(new Error("请输入姓名"));
                    }
                } else {
                    this.$util.validateName(rule, value, callback);
                }
            }
            callback();
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.dis) {
                callback();
            } else {
                if (this.$util.isEmpty(value)) {
                    if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                        callback(new Error("请上传证件获取证件号码"));
                    } else {
                        callback(new Error("请输入证件号码"));
                    }
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.pwdForm.certType);
                }
            }
            callback();
        },
        checkVailddate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                    callback(new Error("请上传证件获取证件有效期"));
                } else {
                    callback(new Error("请选择证件有效期"));
                }
            }
            callback();
        },
        checkBirthdate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                if (this.pwdForm.certType == "00" && this.hasOcr == "1") {
                    callback(new Error("请上传证件获取出生日期"));
                } else {
                    callback(new Error("请选择出生日期"));
                }
            }
            callback();
        },
        /* 提交表单数据 */
        mobileCheck() {
            if (this.hasTranAcct) {
                this.submitForm("pwdForm");
                return;
            }
            if (this.ocrUpdBtnS && this.ocrupdflag == "0") {
                if (this.pwdForm.certType == "00") {
                    this.$message.warning("请先上传有效证件照");
                } else {
                    this.$message.warning("请先输入个人信息再上传有效证件照");
                }
                return false;
            }
            const _this = this;
            let mes = "";
            // 处理银行卡找回密码表单数据校验
            if (_this.checkBank || (!_this.hasTranAcct && _this.hasTranAcct !== undefined)) {
                for (const key in _this.pwdForm) {
                    if (key !== "verifyCode" && key !== "type") {
                        _this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                mes = str;
                                return false;
                            }
                        });
                    }
                }
            }
            if (mes !== "") {
                return false;
            }
            this.sendBank();
        },
        /* 银行卡鉴权发送鉴权信息 */
        async sendBank(val = "") {
            let _this = this;
            let data = {
                certificatetype: this.pwdForm.certType,
                certificateno: this.pwdForm.certNo,
                custname: this.pwdForm.userName,
                mobileno: this.pwdForm.mobile,
                depositcard: this.pwdForm.bankNo,
                channelid: this.bankInfo.channelid,
                channelname: this.bankInfo.channelname,
                biztype: "03"
                // verifycode: val
            };

            const res = await userApi.sendBindCardSms(data);
            if (res.code === "0") {
                this.mobileVisible = true;
                // _this.time = res.data[0].sendperiod;
                // _this.locked = true;
                // _this.$util.btnDisabled(this);
                // _this.submitForm("pwdForm");
            }

            // this.$util.request("acct/opentradeacct/authsend", data, "POST").then(res => {
            //     if (res.data) {
            //         /* 倒计时 */
            //         if (this.bankInfo.identifytype === "1") {
            //             let result = res.data[0];
            //             if (result.comtype && result.comtype === "socket") {
            //                 this.showAcctPage();
            //             } else {
            //                 _this.time = res.data[0].sendperiod;
            //                 _this.locked = true;
            //                 _this.$util.btnDisabled(this);
            //                 _this.submitForm("pwdForm");
            //             }
            //         } else if (this.bankInfo.identifytype === "2") {
            //             this.showAcctPage();
            //         } else if (this.bankInfo.identifytype === "3") {
            //             const pageUrl = res.data[0].url;
            //             this.$util.newWinOpen(pageUrl);
            //             this.$util.confirmBankAuth(this, {}, "acct/opentradeacct/authresult", function () {
            //                 _this.showAcctPage();
            //             });
            //         }
            //     }
            // });
        },
        gotoOcr() {
            let _this = this;
            let checkArtOcrForm = true;
            if (this.hasOcr !== "1") {
                for (const key in _this.pwdForm) {
                    if (
                        key == "userName" ||
                        key == "certType" ||
                        key == "certNo" ||
                        key == "vailddate" ||
                        key == "birthdate"
                    ) {
                        _this.$refs["pwdForm"].validateField(key, function (str) {
                            if (str) {
                                checkArtOcrForm = false;
                            }
                        });
                    }
                }
            }
            // ocr走人工审核需要姓名，证件号码、证件有效期、出生日期
            if (this.hasOcr !== "1" && !checkArtOcrForm) {
                // todo
            } else {
                if (this.ocrupdflag === "1") {
                    const _this = this;
                    this.$confirm("已成功上传身份证件，是否重新上传？", "重新上传", {
                        confirmButtonText: "重新上传",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        _this.ocrShow = true;
                        _this.navs = [
                            { val: "身份验证(上传证件照)", active: true },
                            { val: "补充资料" },
                            {
                                val: "完成绑定",
                                icon: "fa fa-check"
                            }
                        ];
                    });
                } else {
                    this.ocrShow = true;
                    this.navs = [
                        { val: "身份验证(上传证件照)", active: true },
                        { val: "补充资料" },
                        { val: "完成绑定", icon: "fa fa-check" }
                    ];
                }
            }
        },
        imgUp(flag) {
            this.ocrupdflag = "1";
            this.dateSet.dis = true;
            this.dateSetBirth.dis = true;
            if (flag) {
                this.pwdForm.certNo = flag.certificateno;
                this.pwdForm.userName = flag.custname;
                this.pwdForm.vailddate = flag.vailddate;
                this.pwdForm.birthdate = flag.birthdate;
                this.pwdForm.address = flag.address;
            }
            this.dateSet.val = this.$util.fmtDate(this.pwdForm.vailddate);
            this.dateSetBirth.val = this.$util.fmtDate(this.pwdForm.birthdate);
            this.$message({
                type: "success",
                message: "上传证件成功！"
            });
            this.ocrShow = false;
            this.$set(this.navs[0], "val", "身份验证");
        },
        regression() {
            this.ocrShow = false;
            this.$set(this.navs[0], "val", "身份验证");
            // this.navs = [{ val: "身份验证", active: true }, { val: "补充资料" }, { val: "完成绑定", icon: "fa fa-check" }];
        },
        /* 返回上一页页 */
        backPage() {
            this.$router.push({ name: "home" });
        },
        dateInterval(val) {
            this.pwdForm.vailddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.pwdForm.validateField("vailddate");
        },
        dateInterval_birth(val) {
            this.pwdForm.birthdate = val !== null ? val.replace(/-/g, "") : "";
        },
        getOcrOpenStatus() {
            const _this = this;
            const _x = this.$util.src("/acct/ocr/check", {}, true);
            const _data = {};
            this.$req({
                method: "GET",
                url: _x,
                timeout: 20000,
                data: _data
            })
                .then((res) => {
                    if (res.code === "0000000") {
                        if (res.record[0][0].isOpenOcr == "1") {
                            _this.ocrUpdBtnS = true;
                            _this.btnStyle = "38%";
                            // ump开关(走ocr还是人工审核)
                            if (_this.pwdForm.certType === "00" && _this.hasOcr == "1") {
                                _this.dateSet.dis = true;
                                _this.dateSetBirth.dis = true;
                            } else {
                                _this.dateSet.dis = false;
                                _this.dateSetBirth.dis = false;
                            }
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(() => {});
        },
        initBirthdate() {
            // 身份证
            if (this.pwdForm.certType === "00") {
                const sIdNo = this.pwdForm.certNo;
                const that = this;
                const isTrue = that.$util.checkIdCard(sIdNo);
                if (sIdNo.trim() === "") {
                    this.pwdForm.vailddate = ``;
                    this.$set(this.dateSet, "val", ``);
                    this.$set(this.dateSet, "val", "");
                    this.$set(this.dateSet, "time", new Date().getTime());
                }
                if (isTrue) {
                    if (sIdNo.length === 15) {
                        that.pwdForm.birthdate = "19" + sIdNo.substr(6, 6);
                    } else if (sIdNo.length === 18) {
                        that.pwdForm.birthdate = sIdNo.substr(6, 8);
                    }
                } else {
                    that.pwdForm.birthdate = "";
                }
                that.$set(
                    that.dateSetBirth,
                    "val",
                    that.$util.fmtDate(that.pwdForm.birthdate, "-")
                );
                // that.$util.validateCertNo("",sIdNo,function(){
                //     if (sIdNo.length === 15) {
                //         that.pwdForm.birthdate = "19" + sIdNo.substr(6, 6);
                //     } else if (sIdNo.length === 18) {
                //         // if (that.$util.checkIdCard(sIdNo))  {
                //             that.pwdForm.birthdate = sIdNo.substr(6, 8);
                //         // } else {
                //         //     that.pwdForm.birthdate = ""
                //         // }

                //     } else {
                //         that.pwdForm.birthdate = ""
                //     }
                //     that.$set(that.dateSetBirth, "val", that.$util.fmtDate(that.pwdForm.birthdate, "-"));
                // },"0");
            }
        },
        dealValid(val) {
            this.pwdForm.validtype = val ? "1" : "";
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.comp-bind-acct {
    .acct-con {
        padding: 20px;
        .cert-types-line {
            > .el-form-item__content {
                > .el-select {
                    width: 38%;
                    padding-right: 2%;
                }
                > .el-button {
                    width: 10%;
                    padding: 12px 0px;
                }
            }
        }
        .investor-data-up {
            margin-top: 20px;
        }
        .cant-info {
            text-align: center;
            font-size: 18px;
            color: #333333;
            line-height: 30px;
            margin: 20px auto;
        }
        .cant-up {
            margin: 30px auto;
            width: 100%;
            text-align: center;
        }
        .birthdate-select .el-checkbox.date-check {
            display: none;
        }
    }
}
</style>
